<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12 sm12 md12>
        <v-card elevation="1">
          <v-card-text>
            <v-layout row>
              <v-flex xs12 sm8 offset-sm2 md8 offset-md2 style="text-align: center">
                <v-icon :size="80" color="primary">
                  insert_drive_file
                </v-icon>
                <h2 style="color: #1a1a1a; margin: 10px 0px">Import from a CSV file</h2>

                <p style="color: #242424; font-size: 14px; ">Download the sample file and get started</p>
                <v-btn color="primary" href="./sampleData/BulkMemberSample.csv" download
                  >Download</v-btn
                >
              </v-flex>

              <v-flex xs12 sm8 offset-sm2 md8 offset-md2 style="text-align: center">
                <h5 style="color: #1a1a1a; margin: 7px 0px; font-size: 11px; font-weight: 400">
                  Note: Fill the sample file and upload
                </h5>
                <v-file-input label="File input" outlined dense @change="upload"></v-file-input>
              </v-flex>
            </v-layout>
          </v-card-text>

          <!--Table selection  -->
          <v-flex xs12 sm10 offset-sm1 v-if="fileName">
            <v-card elevation="0" style="margin: 10px 5px 10px 5px; padding:5px 25px">
              <v-layout wrap>
                <v-flex xs9 sm10 md10 style="text-align: left">
                  <v-autocomplete
                    label="Enter Timezone"
                    v-model="TimeZone.name"
                    :items="timeZones"
                    persistent-hint
                    outlined
                    dense
                    required
                    chips
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 sm2 md2 style="text-align: center !important;">
                  <v-btn
                    fab
                    slot="activator"
                    text
                    small
                    @click.native="autoDetectTimeZone"
                    > <v-icon>my_location</v-icon></v-btn
                  >
                </v-flex>

                <!-- <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'First Name'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="First Name"
                                    :items = "headerList"
                                    v-model="bulkSelected.FirstName"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Last Name'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Last Name"
                                    :items = "headerList"
                                    v-model="bulkSelected.LastName"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Email'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Email"
                                    :items = "headerList"
                                    v-model="bulkSelected.Email"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>
                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Password'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Password"
                                    :items = "headerList"
                                    v-model="bulkSelected.Password"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Phone Number'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Phone Number"
                                    :items = "headerList"
                                    v-model="bulkSelected.PhoneNumber"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Role'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Role"
                                    :items = "headerList"
                                    v-model="bulkSelected.Role"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Groups'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Groups"
                                    :items = "headerList"
                                    v-model="bulkSelected.Groups"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Supervisors'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Supervisors"
                                    :items = "headerList"
                                    v-model="bulkSelected.Supervisors"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Location'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Location"
                                    :items = "headerList"
                                    v-model="bulkSelected.Location"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Shift'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Shift"
                                    :items = "headerList"
                                    v-model="bulkSelected.Shift"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Tags'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Tags"
                                    :items = "headerList"
                                    v-model="bulkSelected.Tags"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'Forms'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="Forms"
                                    :items = "headerList"
                                    v-model="bulkSelected.Forms"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'WeeklyOffSets'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="WeeklyOffSets"
                                    :items = "headerList"
                                    v-model="bulkSelected.WeeklyOffSet"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'HolidaySets'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="HolidaySet"
                                    :items = "headerList"
                                    v-model="bulkSelected.HolidaySet"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'modifyLocation'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="modifyLocation"
                                    :items = "headerList"
                                    v-model="bulkSelected.modifyLocation"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'modifyUser'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="modifyUser"
                                    :items = "headerList"
                                    v-model="bulkSelected.modifyUser"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'modifyTimesheet'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="modifyTimesheet"
                                    :items = "headerList"
                                    v-model="bulkSelected.modifyTimesheet"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'modifyShifts'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="modifyShifts"
                                    :items = "headerList"
                                    v-model="bulkSelected.modifyShifts"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'modifyHolidays'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="modifyHolidays"
                                    :items = "headerList"
                                    v-model="bulkSelected.modifyHolidays"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'modifyWeeklyOffs'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="modifyWeeklyOffs"
                                    :items = "headerList"
                                    v-model="bulkSelected.modifyWeeklyOffs"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'modifyForms'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="modifyForms"
                                    :items = "headerList"
                                    v-model="bulkSelected.modifyForms"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'isGeoseal'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="isGeoseal"
                                    :items = "headerList"
                                    v-model="bulkSelected.Geoseal"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'isPhotoid'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="isPhotoid"
                                    :items = "headerList"
                                    v-model="bulkSelected.Photoid"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'isWifissid'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="isWifissid"
                                    :items = "headerList"
                                    v-model="bulkSelected.Wifissid"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'MatchDevice'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="matchDevice"
                                    :items = "headerList"
                                    v-model="bulkSelected.MatchDevice"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'FieldTracking'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="FieldTracking"
                                    :items = "headerList"
                                    v-model="bulkSelected.FieldTracking"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>
                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'FieldTrackingPhotoId'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="FieldTrackingPhotoId"
                                    :items = "headerList"
                                    v-model="bulkSelected.FieldTrackingPhotoId"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>
                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'FieldTrackingAllowedForms'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="FieldTrackingAllowedForms"
                                    :items = "headerList"
                                    v-model="bulkSelected.FieldTrackingAllowedForms"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex>

                                <v-flex xs4 sm4>
                                    <v-subheader class="bi_subheader" v-text="'RealTime FieldTracking'"></v-subheader>
                                </v-flex>
                                <v-flex xs8 sm8>
                                    <v-select
                                    label="RealTime FieldTracking"
                                    :items = "headerList"
                                    v-model="bulkSelected.RealTimeFieldTracking"
                                    hint="pick the column you want to select"
                                    persistent-hint
                                    ></v-select>
                                </v-flex> -->

                <v-flex xs12 sm12 md12 style="text-align: center; margin: 5px 0px"> 
                  <p class="bi_p" v-if="fileName">Your selected file is - {{ fileName }}</p>
                  <v-btn color="primary" style="margin: 5px 0px" :disabled="uploaded" @click="save"
                    >Start</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="finishDialog" max-width="800">
      <v-card style="padding: 15px;">
        <v-card-text>
          <v-container>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 v-if="errorMessage.length > 0">
                <v-layout row>
                  <v-flex xs12 sm12 md12>
                    <v-data-table
                      :headers="headers"
                      class="elevation-1"
                      :items="errorMessage"
                    >
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 v-else style="text-align: center">
                <v-icon :size="80" color="success">
                  check_circle_outline
                </v-icon>
                <h2 style="color: #1a1a1a; margin: 15px 0px">Successfully uploaded</h2>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="border-radius: 2px;" color="primary" @click.native="close">Finish</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- loader -->
    <v-dialog
      v-model="loader"
      persistent
      width="300"
      style="box-shadow: none !important;  background-color: transparent !important"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Papa from "papaparse";
import Blob from "blob";
import FileSaver from "file-saver";
import { error } from "util";
import moment from "moment-timezone";
import { checkServerIdentity } from "tls";

export default {
  name: "parse",
  data: () => ({
    loader: false,
    finishDialog: false,
    uploaded: false,
    dataAfterProcess: [],
    fileName: "",
    errorMessage: [],
    headerList: [],
    results: [],
    groups: [],
    forms: [],
    allowedHolidaySets: [],
    allowedWeeklyOffSets: [],
    allowedTags: [],
    allowedShifts: [],
    TimeZone: {
      name: "",
      offset: ""
    },
    // bulk import fields
    bulkSelected: {
      FirstName: "",
      LastName: "",
      EmployeeCode: "",
      Email: "",
      Password: "",
      PhoneNumber: "",
      Role: "",
      Groups: "",
      Supervisors: "",
      Location: "",
      Shift: "",
      Tags: "",
      Forms: "",
      WeeklyOffSet: "",
      HolidaySet: "",
      modifyLocation: "",
      modifyUser: "",
      modifyTimesheet: "",
      modifyShifts: "",
      modifyHolidays: "",
      modifyWeeklyOffs: "",
      modifyForms: "",
      allowHuddle: "",
      Geoseal: "",
      Photoid: "",
      Wifissid: "",
      MatchDevice: "",
      CovidAlert: "",
      FieldTracking: "",
      FieldTrackingPhotoId: "",
      FieldTrackingAllowedForms: "",
      RealTimeFieldTracking: ""
    },
    headers: [
      {
        text: "Email",
        align: "left",
        sortable: false,
        value: "data"
      },
      { text: "Message", value: "message", sortable: false },
      { text: "Success", value: "success", sortable: false }
    ]
  }),
  computed: {
    timeZones() {
      return moment.tz.names();
    },
    pagination: {
      get: function() {
        if (this.$store.getters.pagination) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        }
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });
      }
    }
  },
  created() {
    this.getGroups();
    this.getHolidaySet();
    this.getWeeklyOffSet();
    this.getForms();
    this.getTags();
    this.getShift();
  },
  methods: {
    successState(v) {
      try {
        if (v) {
          return "True";
        } else {
          return "False";
        }
      } catch (e) {
        return "False";
      }
    },
    close() {
      var self = this;
      self.finishDialog = false;
      self.$router.replace({
        path: "/members"
      });
    },
    autoDetectTimeZone() {
      const self = this;
      self.TimeZone.name = moment.tz.guess();
    },
    getForms() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}forms?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.forms = response.body;
        })
        .catch(err => {
          this.$swal({type: "error", text: "Something went wrong"})
        });
    },
    getGroups() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}groups?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.groups = response.body;
        })
        .catch(error => {
          this.$swal({type: "error", text: "Something went wrong"})
        });
    },

    getHolidaySet() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}holidaysets?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.allowedHolidaySets = response.body;
        })
        .catch(err => {
          self.$swal({ type: "error", text: "Sorry, try again later" });
        });
    },
    getTags() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}tags?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.allowedTags = response.body;
        })
        .catch(err => {
          this.$swal({type: "error", text: "Something went wrong"})
        });
    },
    getWeeklyOffSet() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}weeklyoffsets?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.allowedWeeklyOffSets = response.body;
        })
        .catch(err => {
          self.$swal({ type: "error", text: "Sorry, try again later" });
        });
    },
    getShift() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}shifts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          self.allowedShifts = response.body;
        })
        .catch(err => {
          self.$swal({ type: "error", text: "Sorry, try again later" });
        });
    },
    upload(e) {
      const self = this;
      self.fileName = e.name;
      const fileToLoad = event.target.files[0];
      const reader = new FileReader();

      reader.onload = fileLoadedEvent => {
        Papa.parse(fileLoadedEvent.target.result, {
          header: true,
          skipEmptyLines: true,
          keepEmptyRows:false,
          complete(results) {
            self.doc = JSON.stringify(results.data, null, 2);
            self.results = results.data;
            var head = Object.keys(results.data[0]);
            self.headerList = head;
            // Gussing the headers
            const mySelections = Object.keys(self.bulkSelected);
            mySelections.forEach(ms => {
              self.bulkSelected[ms] =
                _.find(
                  head,
                  o =>
                    o
                      .replace(" ", "")
                      .toLowerCase()
                      .trim() ==
                    ms
                      .replace(" ", "")
                      .toLowerCase()
                      .trim()
                ) || "";
            });
          },
          error(errors) {
          }
        });
      };
      reader.readAsText(fileToLoad);
    },

    save() {
      const self = this;
      var data = self.results;
      const { bulkSelected } = self

      let hasError = false;
      for (const x in bulkSelected) {
        if (bulkSelected[x] == "") hasError = true;
      }

      if(hasError) {
        this.$swal({ type: "warning", text: "Please use the provided template" });
        return;
      }

      if (this.$store.state.userDetails.role.toLowerCase() != "superadmin") {
        this.$swal({
          type: "warning",
          text: "Only Superadmin is allowed to operate Bulk operation"
        });
        return;
      }
      
      if(this.TimeZone.name == "") {
        this.$swal({type: "warning", text: "Timezone not selected"})
        return
      };

     // console.log("DATA",data)

     // return

      this.loader = true;
      self.errorMessage = []

      // Let's filter the data and remove bad values
      data = _.map(data, d => {
        let errors = false;

        //Check if the first Name is undefined and blank
        if (typeof d.FirstName === "undefined" || d.FirstName == "") {
          errors = true;
          self.errorMessage.push({
            data: d.Email,
            message: "Invalid first name",
            success: false
          });
        }

        if (d.EmployeeCode == "" || typeof d.EmployeeCode == "undefined") {

            d.EmployeeCode = d.FirstName.substring(0, 2) + Math.floor((Math.random() * 10000) + 1)

        }else{

            d.EmployeeCode =  d.EmployeeCode

        }

        // email
        if(d.Email == "") {
          errors = true;
          self.errorMessage.push({
            data: "Email ID not found",
            message: "Email ID is not provided",
            success: false
          });
        }

        // role
        if(d.Role == "") {
          errors = true;
          self.errorMessage.push({
            data: d.Email,
            message: "Role is not defined",
            success: false
          });
        }
        // group
        if(d.Groups == "") {
          errors = true;
          self.errorMessage.push({
            data: d.Email,
            message: "Group is not mentioned",
            success: false
          });
        }
        // location
        if(d.Location == "") {
          errors = true;
          self.errorMessage.push({
            data: d.Email,
            message: "Location is not provided",
            success: false
          });
        }
        // Supervisor
        if(d.Supervisors == "") {
          errors = true;
          self.errorMessage.push({
            data: d.Email,
            message: "Supervisors is not mentioned",
            success: false
          });
        }

        // Admin cannot create superadmin
        if (
          this.$store.state.userDetails.role.toLowerCase() == "admin" &&
          d.Role.toString().toLowerCase() == "superadmin"
        ) {
          errors = true;
          self.errorMessage.push({
            data: d.Email,
            message: "Admin cannot add Super Admin",
            success: false
          });
        }

        // Group names must be valid and must be in allowed set
        if (d.Groups != "") {
          const groupsInValid = _.includes(
            _.map(d.Groups.split(","), g => {
              if (_.find(self.$store.getters.groups, gs => gs.name == g)) {
                return true;
              }
            }),
            undefined
          );

          if (groupsInValid) {
            errors = true;
            self.errorMessage.push({
              data: d.Email,
              message: "Unmapped/unavailable Groups",
              success: false
            });
          }
        }

        // Location name must be valid and must be in allowed set
        if (d.Location != "") {
          const locationInValid = _.includes(
            _.map(d.Location.split(","), g => {
              if (_.find(self.$store.getters.locationDetails, gs => gs.name == g)) {
                return true;
              }
            }),
            undefined
          );

          if (locationInValid) {
            errors = true;
            self.errorMessage.push({
              data: d.Email,
              message: "Unmapped/unavailable Locations",
              success: false
            });
          }
        }

        // checking for Forms
        

        if (d.Forms != "") {
          var isFormValid = _.includes(
            _.map(d.Forms.trim().toLowerCase().split(","), af => {
              if (
                _.find(self.forms, f => {
                  return f.name.trim().toLowerCase() == af.trim().toLowerCase();
                })
              ) {
                return true;
              } else {
                return false;
              }
            }),
            true
          );
          if (!isFormValid) {
            errors = true;
            self.errorMessage.push({
              data: d.Email,
              message: "Allowed Form: Invalid Name",
              success: false
            });
          }
        }

        //Checking for fieldtrackingallowedForms
        if (d.FieldTrackingAllowedForms != "") {
          var isAllowedFormValid = _.includes(
            _.map(d.FieldTrackingAllowedForms.trim().toLowerCase().split(","), ft => {
              if (
                _.find(self.forms, f => {
                  return f.name.trim().toLowerCase() == ft.trim().toLowerCase();
                })
              ) {
                return true;
              } else {
                return false;
              }
            }),
            true
          );
          if (!isAllowedFormValid) {
            errors = true;
            self.errorMessage.push({
              data: d.Email,
              message: "Field Tracking Form: Invalid Name",
              success: false
            });
          }
        }

        // Checking for Shifts
        if (d.Shift != "") {
          var isShiftValid = _.includes(
            _.map(d.Shift.split(","), as => {
              if (
                _.find(self.allowedShifts, s => {
                  return s.name == as;
                })
              ) {
                return true;
              } else {
                return false;
              }
            }),
            true
          );
          if (!isShiftValid) {
            errors = true;
            self.errorMessage.push({
              data: d.Email,
              message: "Invalid Shift Name",
              success: false
            });
          }
        }

        // Checking for weeklyoff
        if (d.WeeklyOffSet != "") {
          var isWeeklyOffValid = _.includes(
            _.map(d.WeeklyOffSet.split(","), aw => {
              if (
                _.find(self.allowedWeeklyOffSets, w => {
                  return w.name == aw;
                })
              ) {
                return true;
              } else {
                return false;
              }
            }),
            true
          );
          if (!isWeeklyOffValid) {
            errors = true;
            self.errorMessage.push({
              data: d.Email,
              message: "Invalid Weekly off",
              success: false
            });
          }
        }

        //Checking for Holiday
        if (d.HolidaySet != "") {
          var isHolidaySetValid = _.includes(
            _.map(d.HolidaySet.split(","), ah => {
              if (
                _.find(self.allowedHolidaySets, h => {
                  return h.name == ah;
                })
              ) {
                return true;
              } else {
                return false;
              }
            }),
            true
          );
          if (!isHolidaySetValid) {
            errors = true;
            self.errorMessage.push({
              data: d.Email,
              message: "Invalid Holiday",
              success: false
            });
          }
        }

        // timezone
        const tz = {
          name: self.TimeZone.name,
          offset: moment()
            .tz(self.TimeZone.name)
            .utcOffset()
        };
        d.Timezone = tz;

        // checking if the tag name is valid
        if (d.Tags != "") {
          var isTagValid = _.includes(
            _.map(d.Tags.split(","), at => {
              if (
                _.find(self.allowedTags, t => {
                  return t.name == at;
                })
              ) {
                return true;
              } else {
                return false;
              }
            }),
            true
          );
          if (!isTagValid) {
            errors = true;
            self.errorMessage.push({
              data: d.Email,
              message: "Invalid Tag Name",
              success: false
            });
          }
        }

        if (!errors) return d;
      });

      data = _.remove(data, undefined)

      const postObj = {
        data,
        selected: {
          firstname: bulkSelected.FirstName,
          lastname: bulkSelected.LastName,
          code: bulkSelected.EmployeeCode,
          email: bulkSelected.Email,
          password: bulkSelected.Password,
          phone: bulkSelected.PhoneNumber,
          role: bulkSelected.Role,
          groups: bulkSelected.Groups,
          supervisors: bulkSelected.Supervisors,
          location: bulkSelected.Location,
          shift: bulkSelected.Shift,
          tags: bulkSelected.Tags,
          forms: bulkSelected.Forms,
          weeklyOffSet: bulkSelected.WeeklyOffSet,
          holidaySet: bulkSelected.HolidaySet,
          modifyLocation: bulkSelected.modifyLocation,
          modifyUser: bulkSelected.modifyUser,
          modifyTimesheet: bulkSelected.modifyTimesheet,
          modifyShifts: bulkSelected.modifyShifts,
          modifyHolidays: bulkSelected.modifyHolidays,
          modifyWeeklyOffs: bulkSelected.modifyWeeklyOffs,
          modifyForms: bulkSelected.modifyForms,
          allowHuddle: bulkSelected.allowHuddle,
          geoseal: bulkSelected.Geoseal,
          photoid: bulkSelected.Photoid,
          wifissid: bulkSelected.Wifissid,
          matchDevice: bulkSelected.MatchDevice,
          detectHotspot: bulkSelected.CovidAlert,
          fieldtracking: bulkSelected.FieldTracking,
          fieldtrackingPhotoId: bulkSelected.FieldTrackingPhotoId,
          fieldtrackingAllowedForms: bulkSelected.FieldTrackingAllowedForms,
          realtimefieldtracking: bulkSelected.RealTimeFieldTracking
        }
      }

      this.uploaded = true

      this.$http
        .post(`${this.$store.state.endpoint}Accounts/bulk/import`, postObj)
        .then(response => {
          this.loader = false;
          const res = response.body;
          for (var x in res) {
            var errors = res[x].errors;
            _.each(errors, e => {
              return (errors = e);
            });
            
            self.errorMessage.push({
              data: x,
              message: errors,
              success: res[x].success
            });
          }
          self.finishDialog = true;
        })
        .catch(err => {
          self.uploaded = false;
          this.loader = false;
          this.$swal({ type: "error", text: "Sorry, try again later" });
        });
    }
  }
};
</script>
<style scoped>
.bi_p {
  font-size: 12px;
  margin: 10px 0px 2px 0px;
  font-weight: 600;
}
.bi_execute {
  font-size: 14px;
  text-transform: none;
  box-shadow: 1px 2px 20px #ebeaea !important;
  border-radius: 2px;
  font-weight: 400;
}
hr {
  margin: 10px 0px 10px 0px;
  border: 0.5px solid #ebeaea;
}
.bi_subheader {
  margin-top: 20px;
}
.bi_card {
  box-shadow: 1px 2px 20px #ebeaea !important;
  padding: 15px;
  text-align: center;
}
.bi_card2 {
  margin: 10px 5px 10px 5px;
  box-shadow: 1px 2px 20px #ebeaea !important;
  padding: 25px;
}
h3 {
  font-size: 16px;
  letter-spacing: 0.5px;
  margin: 5px 0px 10px 0px;
}
p {
  font-size: 12px;
  letter-spacing: 1px;
  /* text-align: left; */
  font-weight: 600;
}
.bi_btn {
  font-size: 14px;
  text-transform: none;
  box-shadow: 1px 2px 20px #ebeaea !important;
  border-radius: 2px;
  font-weight: 400;
  margin-top: -5px;
}
.bi_file {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
}
.bi_selectFile {
  font-weight: 600;
  letter-spacing: 0.5px;
  font-size: 14px;
  cursor: pointer;
  padding: 5px;
}
.gps-btn {
  margin-top: -7px;
}
th {
  padding: 10px;
}
td {
  padding: 10px;
}
h4 {
  font-size: 15px;
  letter-spacing: 1px;
  margin-bottom: 6px;
}
h5 {
  font-size: 15px;
  letter-spacing: 0.7px;
  font-weight: 600;
}
</style>
